import React, { useState } from "react";
import { cx } from "../../Util/classHelpers";
import ManagingStructureTree from "./ManagingStructureTree";
import styles from "./profileManaging.module.css";

const ManagingInfoSection = ({ managingText }) => {
  const [structureOpen, setStructureOpen] = useState(false);

  return (
    <div
      className={cx(
        styles.managingWrap,
        structureOpen && styles.managingWrapOpen,
      )}
    >
      <div
        className={cx(
          "single-info",
          "justify-content-between",
          styles.managingRow,
        )}
      >
        <div className="info-header">
          <span>Managing:</span>
        </div>
        <div className={cx("info-text", styles.managingInfoText)}>
          <span>{managingText}</span>
          <button
            type="button"
            className={cx(
              styles.managingChevronBtn,
              structureOpen && styles.managingChevronOpen,
            )}
            onClick={() => setStructureOpen((open) => !open)}
            aria-expanded={structureOpen}
            aria-label={
              structureOpen
                ? "Hide organization structure"
                : "Show organization structure"
            }
          />
        </div>
      </div>
      {structureOpen && <ManagingStructureTree />}
    </div>
  );
};

export default ManagingInfoSection;
